import prismicAPI from '@/helpers/prismic-api'

export default function () {
  // On route change, clear the current copy of the API for Prismic
  // This is required to get the latest version of the Prismic content
  // https://prismic.io/docs/javascript/getting-started/integrating-with-an-existing-javascript-project#4_0-3.-connect-to-the-api-and-query-your-content
  prismicAPI.clearAPI()
}
